import GoogleMapReact from 'google-map-react';
import { ComponentProps } from 'react';
import { useDetectClickOutside } from 'react-detect-click-outside';
import EFEmail from '@/components/UI/svg/WTB/EFEmail';
import EFPhone from '@/components/UI/svg/WTB/EFPhone';
import EFClock from '@/components/UI/svg/WTB/EFClock';
import EFGlobal from '@/components/UI/svg/WTB/EFGlobal';
import EFLocation from '@/components/UI/svg/WTB/EFLocation';
import { handleDynamicPath } from '@/utils/handleDynamicPath';
import { useGlobal } from '@/utils/useGlobal';

export default function GoogleMap({ center, zoom, storeLists, logoCard }: any) {
    const { useRouter, useEffect, useState, useRef } = useGlobal();
    const { locale } = useRouter();
    const googleMapRef = useRef<Parameters<Exclude<ComponentProps<typeof GoogleMapReact>['onGoogleApiLoaded'], undefined>>[0]>();
    const [showLogoCard, setShowLogoCard] = useState<any>({ show: false, data: {} });

    const onHandleClick = (e: any, store: any) => {
        e.stopPropagation();
        if (logoCard?.show && store?.id !== logoCard?.data?.id) {
            logoCard.show = false;
        }
        setShowLogoCard({ show: true, data: store });
    };

    useEffect(() => {
        if (storeLists.length === 1) {
            setShowLogoCard({ show: true, data: storeLists[0] });
        } else {
            setShowLogoCard({ show: false, data: {} });
        }
    }, [storeLists]);

    useEffect(() => {
        if (!googleMapRef.current) return;
        googleMapRef.current.map.setCenter(center);
    }, [center]);

    useEffect(() => {
        if (!googleMapRef.current) return;
        googleMapRef.current.map.setZoom(zoom);
    }, [zoom]);

    return (
        <GoogleMapReact
            bootstrapURLKeys={{
                key: 'AIzaSyAEY5R902_gyPQQ8QqJiDe-rpu2x6naPDw',
                language: ['us', 'ca', 'au', 'ph', 'uk', 'za', 'eu'].includes(locale || '') ? 'en' : locale === 'jp' ? 'ja' : locale === 'br' ? 'pt' : locale,
            }}
            defaultCenter={center}
            defaultZoom={zoom}
            onGoogleApiLoaded={(googleMapIns) => {
                googleMapRef.current = googleMapIns;
            }}
        >
            {storeLists?.map((store: any) => (
                <MapMarker
                    show={
                        (store?.latitude === showLogoCard?.data?.latitude &&
                            store?.longitude === showLogoCard?.data?.longitude &&
                            showLogoCard?.show &&
                            store?.id === showLogoCard?.data?.id) ||
                        (logoCard?.show && logoCard.data?.latitude && store?.longitude === logoCard?.data?.longitude && store?.id === logoCard?.data?.id)
                    }
                    lat={store.latitude}
                    lng={store.longitude}
                    key={`${store.id}_${store.latitude}_${store.longitude}`}
                    item={store}
                    logoCard={logoCard}
                    onClick={(e: any) => onHandleClick(e, store)}
                    onTriggered={() => {
                        setShowLogoCard({ show: false, data: store });
                        logoCard.show = false;
                    }}
                />
            ))}
        </GoogleMapReact>
    );
}

// 非cn站的info弹窗及
const MapMarker = ({ item, show, onClick, lat, lng, logoCard, onTriggered, key }: any) => {
    const outsideRef = useDetectClickOutside({
        onTriggered: onTriggered,
    });
    return (
        <div ref={outsideRef} className={`imgLogoBox google_marker_${key}`} onClick={onClick}>
            {show && (
                <div className="modalBox">
                    <div className="innerBox">
                        {item?.name && <div className="store_name">{item?.name}</div>}
                        {item?.address && !item?.virtualFlag && (
                            <div className="store_address common">
                                <div className="icon">
                                    <EFLocation />
                                </div>
                                <div className="text">{item?.address}</div>
                            </div>
                        )}
                        {item?.phone && (
                            <div className="store_phone common">
                                <div className="icon">
                                    <EFPhone />
                                </div>
                                <a className="text" href={`tel:${item?.phone}`}>
                                    {item?.phone}
                                </a>
                            </div>
                        )}
                        {item?.email && (
                            <div className="store_email common">
                                <div className="icon">
                                    <EFEmail />
                                </div>
                                <a className="text" href={`mailto:${item?.email}`}>
                                    {item?.email}
                                </a>
                            </div>
                        )}
                        {item?.webLink && (
                            <div className="store_website common">
                                <div className="icon">
                                    <EFGlobal />
                                </div>
                                <a className="text" href={item?.webLink} target="_blank" rel="noreferrer">
                                    {item?.webLink}
                                </a>
                            </div>
                        )}
                        {item?.businessTime && (
                            <div className="store_openTime common">
                                <div className="icon">
                                    <EFClock />
                                </div>
                                <div className="text">{item?.businessTime}</div>
                            </div>
                        )}
                        {item?.label && (
                            <div className="store_tags">
                                {item?.label?.split(';')?.map((tag: any, m: number) => (
                                    <li className="store_tag_item" key={`${item.latitude}_${item.longitude}_logo_tag_${m}`}>
                                        {tag}
                                    </li>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            )}
            <img
                className="imgLogo fullImgs"
                src={handleDynamicPath(`/media/wheretobuy/retail/logo_${item?.virtualFlag ? 'white' : 'black'}.svg`)}
                width={40}
                height={40}
                alt={item?.name}
                aria-label={item?.name}
            />
        </div>
    );
};
